import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import {
    ListarProdutosPorEmpreendimentosController,
    ListarEmpreendimentosModuloController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ExportExcelListarVistoriasController } from "../../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";

import { IGestaoDeEntregaChavesRequest } from "../../../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import Select from "react-select";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ListarEtapasPorCategoriaAtendimentoOuTipoCasoController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { useModuloInfo } from "../../../../Context/ModuloInfo";

interface IGestaoDeEntregaChavesProps {
    handleSubmit: (filter: IGestaoDeEntregaChavesRequest) => void;
    defaultFilter?: IGestaoDeEntregaChavesRequest;
    setIdEmpreendimento: Dispatch<SetStateAction<number | string | number[]>>;
    idEmpreendimento: string | number | number[];
}

const filtroInicial = {
    ID_PRODUTO_PAI: [] as number[],
    DT_INICIO: "",
    DT_FIM: "",
    PAGINA: 1,
    PESQUISA: "",
    DS_NOME: "",
    ID_CASO: 0,
    ID_UNIDADE: [] as number[],
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS: [] as number[],
    ID_ETAPA_TIPO_CASO: [] as number[],
    DS_PROCESSO_VISTORIA: "",
};

export default function FiltroEntregaChaves(
    props: IGestaoDeEntregaChavesProps
) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm();
    const { reset, setValue, register, handleSubmit } = FormMethods;

    const { execute: listarUnidades, value: unidadesListadas } =
        useAsyncCallback(ListarProdutosPorEmpreendimentosController);

    const idEtapaRef = useRef<any>();
    const idEmpreendimentoRef = useRef<any>();
    const idUnidadeRef = useRef<any>();
    const dsProcessoVist = useRef<any>();

    const { id } = useModuloInfo();

    const statusOptions = [
        { value: "", label: "" },
        { value: "PARALISADO", label: "Paralisado" },
        { value: "FINALIZADO", label: "Finalizado" },
        { value: "INICIADO", label: "Iniciado" },
        { value: "NAO_INICIADO", label: "Não Iniciado" },
    ];

    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
        idUnidadeRef.current?.clearValue();
        idEtapaRef.current?.clearValue();
        dsProcessoVist.current?.clearValue();
        setValue("ID_UNIDADE", []);
        setValue("ID_PRODUTO_PAI", []);
        setValue("ID_ETAPA_TIPO_CASO", []);
        setValue("DS_PROCESSO_VISTORIA", "");
    };

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const [optionsProdutos, setOptionsProdutos] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const [optionsEtapas, setOptionsEtapas] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    // const { execute: listarEtapas } = useAsyncCallback(
    //     () =>
    //         ListarEtapasPorCategoriaAtendimentoOuTipoCasoController(
    //             10
    //         ),
    //     []
    // );

    const { value: listarEtapas } = useAsyncEffect(
        () => ListarEtapasPorCategoriaAtendimentoOuTipoCasoController(10),
        []
    );

    const { value: listarEmpreendimentos } = useAsyncEffect(async () => {
        if (id) return ListarEmpreendimentosModuloController(id);
    }, [id]);

    const onSubmit = (data: IGestaoDeEntregaChavesRequest) => {
        hadleFilterFormSubmit({
            ...data,
            ID_PRODUTO_PAI: props.idEmpreendimento,
        });
    };

    useEffect(() => {
        setOptionsEtapas(() =>
            listarEtapas?.map((etapa) => ({
                label: etapa.DS_ETAPA,
                value: etapa.ID_ETAPA_TIPO_CASO,
            }))
        );
    }, [listarEtapas]);

    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);

    useEffect(() => {
        setOptionsProdutos(() =>
            unidadesListadas?.map((produto) => ({
                label: produto.DS_PRODUTO,
                value: produto.ID_PRODUTO,
            }))
        );
    }, [unidadesListadas]);

    useEffect(() => {
        register("ID_PRODUTO_PAI");
        register("ID_UNIDADE");
        register("ID_ETAPA_TIPO_CASO");
        register("DS_PROCESSO_VISTORIA");
    }, [register]);

    return (
        <>
            <StickyToolbar active={Boolean(filter)}>
                <FormProvider {...FormMethods}>
                    <UnForm handleSubmit={handleSubmit(onSubmit)} usingContext>
                        <div className="col-12 mt-3">
                            <label>Data Inicio do Caso</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_INICIO"
                                defaultValue={filter?.DT_INICIO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final do Caso</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_FIM"
                                defaultValue={filter?.DT_FIM}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Caso</label>
                            <UnForm.Input
                                className="form-control"
                                type="number"
                                name="ID_CASO"
                                defaultValue={filter?.ID_CASO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Nome Cliente</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                name="DS_NOME"
                                defaultValue={filter?.DS_NOME}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Etapa</label>
                            <Select
                                options={optionsEtapas}
                                name="ID_ETAPA_TIPO_CASO"
                                ref={idEtapaRef}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    const ids = e.map((item) => item?.value);
                                    setValue("ID_ETAPA_TIPO_CASO", ids);
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                options={options}
                                name="ID_PRODUTO_PAI"
                                ref={idEmpreendimentoRef}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    const ids = e.map(
                                        (item) => item?.value
                                    ) as number[];
                                    props.setIdEmpreendimento(ids);
                                    listarUnidades({
                                        ID_EMPREENDIMENTO: ids,
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className={`col-12 mt-3 `}>
                            <label>Unidade</label>
                            <Select
                                options={optionsProdutos}
                                name="ID_UNIDADE"
                                ref={idUnidadeRef}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    const ids = e.map((item) => item?.value);
                                    setValue("ID_UNIDADE", ids);
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Status</label>
                            <Select
                                options={statusOptions}
                                name="DS_PROCESSO_VISTORIA"
                                isClearable
                                ref={dsProcessoVist}
                                onChange={(selectedOption) => {
                                    setValue(
                                        "DS_PROCESSO_VISTORIA",
                                        selectedOption
                                            ? selectedOption.value
                                            : ""
                                    );
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_VISTORIA"
                                    );
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_VISTORIA_CORTE"
                                    );
                                    reset(filtroInicial);
                                    limparFiltros();
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
            <ExportExcel
                baixarExcelController={async () =>
                    ExportExcelListarVistoriasController(filter ?? {})
                }
                nomeArquivo={`RelatorioEntregaDeChaves`}
            />
        </>
    );
}
